import {
  openModal,
  selectCheck,
  selectOrder,
  useAppDispatch,
  useAppSelector,
  validateOrder,
} from '@open-tender/cloud'
import { cardIconsMap } from 'components/cardIcons'
import CheckoutButton from './CheckoutButton/CheckoutButton'

interface CheckoutCreditCardAddProps {
  isPaid?: boolean
  setCvv?: React.Dispatch<React.SetStateAction<string>>
}

const CheckoutCreditCardAdd = ({ isPaid, setCvv }: CheckoutCreditCardAddProps) => {
  const dispatch = useAppDispatch()
  const { revenueCenter } = useAppSelector(selectOrder)
  const { revenue_center_id = null } = revenueCenter || {}
  const check = useAppSelector(selectCheck)
  const onClick = (evt: React.MouseEvent<HTMLButtonElement>) => {
    evt.preventDefault()
    const args = {
      setCvvCard:(cvv?: string) => {
        if (setCvv) setCvv(cvv || '')
      },
      callback: () => dispatch(validateOrder()),
      revenue_center_id,
      RCrequire_cardholder_name: check?.config.require_cardholder_name || false,
    }
    dispatch(openModal({ type: 'creditCard', args }))
  }

  return (
    <CheckoutButton
      icon={cardIconsMap['OTHER']}
      title="Add new credit card to profile"
      onPress={onClick}
      isApplied={false}
      disabled={isPaid}
      applyText="Add"
    />
  )
}

export default CheckoutCreditCardAdd
